export const variantMap = {
    h1: '1000',
    h2: '900',
    h3: '800',
    h4: '700',
    h5: '700',
    h6: '700',
    p: '100-r',
    span: '100-r',
    div: '100-r',
};
export const isBalancedMap = {
    '1000': true,
    '900': true,
    '800': true,
    '700': true,
    '600': true,
    '200': false,
    '100': false,
    '100-r': false,
    '50': false,
    '50-r': false,
};
